module.exports = __webpack_public_path__ + "img/page-inconnue.001ed3aa.png";